module.exports = __webpack_public_path__ + "media/images/bg-37e2fb95480a430174f64c6c50409204.jpg";